/**
 * G3 -- a figure inside a sentence, isolated from the bidi algorithm.
 *
 * Most numbers in the product already carry `tabular-nums` or
 * `font-mono`, and a CSS rule handles those. This is for the rest: a
 * date, a ratio or a count sitting in running text with no
 * typographic class of its own, where right-to-left reordering would
 * otherwise reverse it.
 *
 * Deliberately a span with a class rather than an inline style, so the
 * rule lives with the others in index.css and one place governs how a
 * figure behaves.
 */
export function Figure({ children }: { children: React.ReactNode }) {
  return <span className="marsad-figure">{children}</span>;
}
